import { useState, useEffect } from 'react';
import './Splash.css';

export default function Splash({ onComplete }) {
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowHint(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleStart = () => {
    onComplete();
  };

  return (
    <div className="splash" onClick={handleStart} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleStart()}>
      <div className="splash__content">
        <div className="splash__brand">
          <div className="splash__logo">IWX</div>
          <div className="splash__since">Since 2025</div>
        </div>
        <h1 className="splash__title">InfiniteWaveX</h1>
        <p className="splash__tagline">Infinite Possibilities, One Platform</p>
      </div>
      <div className={`splash__hint ${showHint ? 'splash__hint--visible' : ''}`}>
        Tap anywhere to begin your experience
      </div>
    </div>
  );
}
